import React, { useEffect, useRef } from "react";
import IconButton from "@mui/material/IconButton";
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/List";
import { TbPackages } from "react-icons/tb";
import { LuPackage2 } from "react-icons/lu";
import { GoPackage } from "react-icons/go";

export default function ProductTypeSelector(props) {
  const { StepCheck, SetStepCheck, view, handleView, refocusView } = props;
  const listRef = useRef(null);
  const gridRef = useRef(null);

  const handletype = (type) => {
    SetStepCheck((step) => {
      return {
        ...step,
        Products: type,
        QuoteCheck: false,
      };
    });
  };

  // The switches sit in the table's toolbar in List view and next to the
  // search box in Grid view, so a List / Grid click shows a new copy of them.
  // The scroller's refocusView ref carries which button was pressed, and the
  // new copy takes focus there, as when the switches stayed in one place.
  useEffect(() => {
    if (!refocusView?.current) return;
    const pressed = refocusView.current === "List View" ? listRef : gridRef;
    refocusView.current = null;
    pressed.current?.focus();
  }, [refocusView]);

  // Each button shows its own view; the one already showing does nothing.
  const pressView = (target, name) => {
    if (target === view) return;
    if (refocusView) refocusView.current = name;
    handleView(target);
  };

  // Products / Bundles / Packages, then List / Grid, as two segmented tracks
  // with visible labels. Same handlers as before (handletype resets the quote,
  // SP-058; List / Grid each show their own view, SP-055 fixed 2026-10-19). The aria-labels are the names the
  // tooltips used to give them.
  const tabs = [
    ["Products", GoPackage],
    ["Bundles", TbPackages],
    ["Packages", LuPackage2],
  ];

  return (
    <>
      <div className="myprod__switches">
        <div className="myprod__seg myprod__seg--tabs" role="group" aria-label="What to add from">
          {tabs.map(([type, TabIcon]) => (
            <div
              key={type}
              aria-label={type}
              className={`myprod__seg-btn${StepCheck["Products"] === type ? " is-on" : ""}`}
              onClick={() => handletype(type)}
            >
              <TabIcon className="myprod__seg-ic" aria-hidden="true" />
              <span className="myprod__seg-label">{type}</span>
            </div>
          ))}
        </div>
        <div className="myprod__seg myprod__seg--view" role="group" aria-label="View">
          <IconButton
            ref={listRef}
            aria-label="List View"
            className={`myprod__seg-btn${view === "List" ? " is-on" : ""}`}
            onClick={() => pressView("List", "List View")}
          >
            <ListIcon className="myprod__seg-ic" aria-hidden="true" />
            <span className="myprod__seg-label">List</span>
          </IconButton>
          <IconButton
            ref={gridRef}
            aria-label="Grid View"
            className={`myprod__seg-btn${view === "Grid" ? " is-on" : ""}`}
            onClick={() => pressView("Grid", "Grid View")}
          >
            <GridViewIcon className="myprod__seg-ic" aria-hidden="true" />
            <span className="myprod__seg-label">Grid</span>
          </IconButton>
        </div>
      </div>
    </>
  );
}
